/// <reference types="./proposals.d.mts" />
import * as $data_point from "../../common/data/data_point.mjs";
import * as $data_source from "../../common/data/data_source.mjs";
import * as $proposal from "../../common/data/proposal.mjs";
import * as $proposal_element from "../../common/data/proposal_element.mjs";
import * as $question from "../../common/data/proposal_element/question.mjs";
import * as $status from "../../common/data/status.mjs";
import * as $uuid from "../../common_common/crypto/uuid.mjs";
import * as $assoc from "../../common_common/gleam/assoc.mjs";
import * as $position from "../../ds/ds/internals/position.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $function from "../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $effect from "../../lustre/lustre/effect.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import {
  Ok,
  Error,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  divideFloat,
  isEqual,
} from "../gleam.mjs";

export class Proposals extends $CustomType {
  constructor(all, filters, filters_opened, selected_questions, add_opened, more_question_opened, more_proposal_opened, more_unsubscriber, block_page_size, collaborators_opened, change_owner_popup_opened, change_status_popup_opened, comment_displayed_opened, emoji_comment_picker_id, title_opened, focus_comment, popup_more_comment_id, elements, improvements_conversations, conversations_input) {
    super();
    this.all = all;
    this.filters = filters;
    this.filters_opened = filters_opened;
    this.selected_questions = selected_questions;
    this.add_opened = add_opened;
    this.more_question_opened = more_question_opened;
    this.more_proposal_opened = more_proposal_opened;
    this.more_unsubscriber = more_unsubscriber;
    this.block_page_size = block_page_size;
    this.collaborators_opened = collaborators_opened;
    this.change_owner_popup_opened = change_owner_popup_opened;
    this.change_status_popup_opened = change_status_popup_opened;
    this.comment_displayed_opened = comment_displayed_opened;
    this.emoji_comment_picker_id = emoji_comment_picker_id;
    this.title_opened = title_opened;
    this.focus_comment = focus_comment;
    this.popup_more_comment_id = popup_more_comment_id;
    this.elements = elements;
    this.improvements_conversations = improvements_conversations;
    this.conversations_input = conversations_input;
  }
}

export class Elements extends $CustomType {
  constructor(by_proposal, data_sources, data_points) {
    super();
    this.by_proposal = by_proposal;
    this.data_sources = data_sources;
    this.data_points = data_points;
  }
}

export function new$() {
  return new Proposals(
    toList([]),
    $proposal.new_filters(),
    false,
    $dict.new$(),
    false,
    new None(),
    new None(),
    new None(),
    40,
    new None(),
    false,
    false,
    false,
    new None(),
    false,
    new None(),
    new None(),
    new Elements($dict.new$(), $dict.new$(), $dict.new$()),
    $dict.new$(),
    $dict.new$(),
  );
}

export function toggle_filters_opened(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    !proposals.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_more_proposal(proposals, id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    (() => {
      let $ = proposals.more_proposal_opened;
      if ($ instanceof $option.Some) {
        let old_id = $[0][0];
        if (old_id === id) {
          return new $option.None();
        } else {
          let value = $;
          return value;
        }
      } else {
        let value = $;
        return value;
      }
    })(),
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function set_filters(proposals, filters) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_filters(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    false,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_comment_more(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    new None(),
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_more_question(proposals, id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    (() => {
      let $ = proposals.more_question_opened;
      if ($ instanceof Some) {
        let old_id = $[0];
        if (old_id === id) {
          return new None();
        } else {
          let value = $;
          return value;
        }
      } else {
        let value = $;
        return value;
      }
    })(),
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_collaborators(proposals, id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    (() => {
      let $ = proposals.collaborators_opened;
      if ($ instanceof Some) {
        let old_id = $[0];
        if (old_id === id) {
          return new None();
        } else {
          let value = $;
          return value;
        }
      } else {
        let value = $;
        return value;
      }
    })(),
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function clear_popup(proposals, route) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    proposals.filters_opened && $result.is_ok($route.current_proposal_id(route)),
    $dict.new$(),
    _record.add_opened,
    new None(),
    new None(),
    _record.more_unsubscriber,
    _record.block_page_size,
    new None(),
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_popups(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    false,
    false,
    _record.comment_displayed_opened,
    new None(),
    false,
    _record.focus_comment,
    new None(),
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function add_questions(proposals, elements) {
  let $ = $list.first(elements);
  if ($ instanceof Ok) {
    let element = $[0];
    let proposal_id = $proposal_element.proposal_id(element);
    let elements$1 = $list.map(
      elements,
      (q) => { return [$proposal_element.id(q), q]; },
    );
    let _pipe = proposals.elements.by_proposal;
    let _pipe$1 = $dict.insert(_pipe, proposal_id, elements$1);
    return ((by_proposal) => {
      let _record = proposals;
      return new Proposals(
        _record.all,
        _record.filters,
        _record.filters_opened,
        _record.selected_questions,
        _record.add_opened,
        _record.more_question_opened,
        _record.more_proposal_opened,
        _record.more_unsubscriber,
        _record.block_page_size,
        _record.collaborators_opened,
        _record.change_owner_popup_opened,
        _record.change_status_popup_opened,
        _record.comment_displayed_opened,
        _record.emoji_comment_picker_id,
        _record.title_opened,
        _record.focus_comment,
        _record.popup_more_comment_id,
        (() => {
          let _record$1 = proposals.elements;
          return new Elements(
            by_proposal,
            _record$1.data_sources,
            _record$1.data_points,
          );
        })(),
        _record.improvements_conversations,
        _record.conversations_input,
      );
    })(_pipe$1);
  } else {
    return proposals;
  }
}

export function update_status(proposals, id, status) {
  let _record = proposals;
  return new Proposals(
    $list.map(
      proposals.all,
      (proposal) => {
        return $bool.guard(
          id !== proposal[0],
          proposal,
          () => {
            return $pair.map_second(
              proposal,
              (proposal) => {
                let _record$1 = proposal;
                return new $proposal.Proposal(
                  _record$1.id,
                  _record$1.project_id,
                  _record$1.org_id,
                  _record$1.name,
                  status,
                  _record$1.display,
                  _record$1.google_sheet_id,
                  _record$1.kind,
                  _record$1.link_id,
                  _record$1.metadata,
                  _record$1.progress,
                  _record$1.created_at,
                );
              },
            );
          },
        );
      },
    ),
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function delete_proposal(proposals, proposal_id) {
  let all = $assoc.remove(proposals.all, proposal_id);
  let _record = proposals;
  return new Proposals(
    all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    (() => {
      let _record$1 = proposals.elements;
      return new Elements(
        $dict.delete$(proposals.elements.by_proposal, proposal_id),
        _record$1.data_sources,
        _record$1.data_points,
      );
    })(),
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function get_elements(proposals, proposal_id) {
  let _pipe = proposals.elements.by_proposal;
  let _pipe$1 = $dict.get(_pipe, proposal_id);
  return $result.unwrap(_pipe$1, toList([]));
}

export function get_questions(proposals, proposal_id) {
  let _pipe = proposals.elements.by_proposal;
  let _pipe$1 = $dict.get(_pipe, proposal_id);
  let _pipe$2 = $result.map(
    _pipe$1,
    (_capture) => {
      return $list.filter_map(
        _capture,
        (element) => {
          let $ = element[1];
          if ($ instanceof $proposal_element.Question) {
            let q = $.question;
            return new Ok([element[0], q]);
          } else {
            return new Error(undefined);
          }
        },
      );
    },
  );
  return $result.unwrap(_pipe$2, toList([]));
}

export function upsert_all(proposals, all) {
  let _record = proposals;
  return new Proposals(
    (() => {
      let _pipe = $list.fold(
        all,
        proposals.all,
        (proposals, proposal) => {
          return $list.key_set(proposals, proposal.id, proposal);
        },
      );
      return $list.sort(
        _pipe,
        (a, b) => {
          return $timestamp.compare(b[1].created_at, a[1].created_at);
        },
      );
    })(),
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function selected_elements_ids(proposals) {
  return $dict.fold(
    proposals.selected_questions,
    toList([]),
    (ids, key, value) => {
      return $bool.guard(!value, ids, () => { return listPrepend(key, ids); });
    },
  );
}

export function toggle_change_status(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    false,
    !proposals.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function toggle_change_owner(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    !proposals.change_owner_popup_opened,
    false,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function toggle_emoji_comment_picker(proposals, target_id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    target_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function close_emoji_comment_picker(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    new None(),
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function toggle_comments_displayed(proposals, target_id, offset, heights) {
  let _block;
  let $ = proposals.comment_displayed_opened;
  let $1 = proposals.focus_comment;
  if ($) {
    if ($1 instanceof Some) {
      let focus = $1[0][0];
      if (focus === target_id) {
        _block = false;
      } else {
        _block = true;
      }
    } else {
      _block = true;
    }
  } else {
    _block = true;
  }
  let comment_displayed_opened = _block;
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    false,
    false,
    comment_displayed_opened,
    new None(),
    _record.title_opened,
    (() => {
      if (comment_displayed_opened) {
        return new Some([target_id, offset, heights]);
      } else {
        return new None();
      }
    })(),
    new None(),
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function toggle_title(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    !proposals.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function is_question_selected(proposals, id) {
  let _pipe = $dict.get(proposals.selected_questions, id);
  return $result.unwrap(_pipe, false);
}

export function select_question(proposals, id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    $dict.insert(proposals.selected_questions, id, true),
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function deselect_question(proposals, id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    $dict.delete$(proposals.selected_questions, id),
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function add_questions_data_sources(proposals, data_sources) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    (() => {
      let _record$1 = proposals.elements;
      return new Elements(
        _record$1.by_proposal,
        $dict.merge(proposals.elements.data_sources, data_sources),
        _record$1.data_points,
      );
    })(),
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function add_questions_data_points(proposals, data_points) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    (() => {
      let _record$1 = proposals.elements;
      return new Elements(
        _record$1.by_proposal,
        _record$1.data_sources,
        $dict.merge(proposals.elements.data_points, data_points),
      );
    })(),
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function start_conversation(proposals, question_id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    (() => {
      let _pipe = proposals.improvements_conversations;
      return $dict.upsert(
        _pipe,
        question_id,
        (_capture) => { return $option.lazy_unwrap(_capture, $uuid.new$); },
      );
    })(),
    _record.conversations_input,
  );
}

export function close_conversation(proposals, question_id) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    (() => {
      let _pipe = proposals.improvements_conversations;
      return $dict.delete$(_pipe, question_id);
    })(),
    _record.conversations_input,
  );
}

export function get_question_sources(proposals, question) {
  let elements = proposals.elements;
  let data_sources = elements.data_sources;
  let data_points = elements.data_points;
  let _block;
  let _pipe = $dict.get(data_sources, question.id);
  _block = $result.unwrap(_pipe, toList([]));
  let data_sources$1 = _block;
  let _block$1;
  let _pipe$1 = $dict.get(data_points, question.id);
  _block$1 = $result.unwrap(_pipe$1, toList([]));
  let data_points$1 = _block$1;
  return [
    data_sources$1,
    $list.filter_map(
      question.data_points_id,
      (_use0) => {
        let data_point_id = _use0[0];
        return $list.find(
          data_points$1,
          (data_point) => { return data_point.id === data_point_id; },
        );
      },
    ),
  ];
}

function update_qa_order(acc, element) {
  let updated_elements = acc[0];
  let index = acc[1];
  let $ = element[1];
  if ($ instanceof $proposal_element.Question) {
    let q = $.question;
    let _block;
    let _record = q;
    _block = new $question.Question(
      _record.id,
      _record.proposal_id,
      _record.data_points_id,
      _record.display,
      _record.owner,
      _record.kind,
      _record.choices,
      _record.sheet,
      _record.content,
      _record.answer,
      _record.validated,
      _record.metadata,
      _record.ai_processing,
      _record.assign_processing,
      index,
      _record.doc_id_order,
    );
    let question = _block;
    let element$1 = [element[0], new $proposal_element.Question(question)];
    return [listPrepend(element$1, updated_elements), index + 1];
  } else {
    return [listPrepend(element, updated_elements), index];
  }
}

export function recompute_qa_order(elements) {
  let _pipe = $list.fold(elements, [toList([]), 0], update_qa_order);
  let _pipe$1 = $pair.first(_pipe);
  return $list.reverse(_pipe$1);
}

function filter_question(proposals, proposal_id, question_id) {
  let _record = proposals.elements;
  return new Elements(
    (() => {
      let _pipe = proposals.elements.by_proposal;
      let _pipe$1 = $dict.get(_pipe, proposal_id);
      let _pipe$2 = $result.map(
        _pipe$1,
        (_capture) => {
          return $list.filter(_capture, (q) => { return q[0] !== question_id; });
        },
      );
      let _pipe$3 = $result.map(_pipe$2, recompute_qa_order);
      let _pipe$4 = $result.map(
        _pipe$3,
        (_capture) => {
          return $dict.insert(
            proposals.elements.by_proposal,
            proposal_id,
            _capture,
          );
        },
      );
      return $result.unwrap(_pipe$4, proposals.elements.by_proposal);
    })(),
    _record.data_sources,
    _record.data_points,
  );
}

function count_validated_questions(questions) {
  return $list.fold(
    questions,
    [0, 0],
    (_use0, _use1) => {
      let validated = _use0[0];
      let total = _use0[1];
      let question = _use1[1];
      if (question instanceof $proposal_element.Question) {
        let question$1 = question.question;
        let $ = question$1.validated;
        if ($) {
          return [validated + 1, total + 1];
        } else {
          return [validated, total + 1];
        }
      } else {
        return [validated, total];
      }
    },
  );
}

function compute_progress(elements) {
  let $ = count_validated_questions(elements);
  let validated = $[0];
  let total = $[1];
  let _pipe = (divideFloat(
    $int.to_float(validated),
    $int.to_float($int.max(total, 1))
  ));
  let _pipe$1 = $float.multiply(_pipe, 100.0);
  return $float.round(_pipe$1);
}

export function set_elements(proposals, proposal_id, elements) {
  let progress = compute_progress(elements);
  let by_proposal = $dict.insert(
    proposals.elements.by_proposal,
    proposal_id,
    elements,
  );
  let _block;
  let _record = proposals.elements;
  _block = new Elements(by_proposal, _record.data_sources, _record.data_points);
  let elements$1 = _block;
  let _record$1 = proposals;
  return new Proposals(
    (() => {
      let _pipe = proposals.all;
      let _pipe$1 = $list.key_find(_pipe, proposal_id);
      let _pipe$2 = $result.map(
        _pipe$1,
        (p) => {
          let _record$2 = p;
          return new $proposal.Proposal(
            _record$2.id,
            _record$2.project_id,
            _record$2.org_id,
            _record$2.name,
            _record$2.status,
            _record$2.display,
            _record$2.google_sheet_id,
            _record$2.kind,
            _record$2.link_id,
            _record$2.metadata,
            progress,
            _record$2.created_at,
          );
        },
      );
      let _pipe$3 = $result.map(
        _pipe$2,
        (_capture) => {
          return $list.key_set(proposals.all, proposal_id, _capture);
        },
      );
      return $result.unwrap(_pipe$3, proposals.all);
    })(),
    _record$1.filters,
    _record$1.filters_opened,
    _record$1.selected_questions,
    _record$1.add_opened,
    _record$1.more_question_opened,
    _record$1.more_proposal_opened,
    _record$1.more_unsubscriber,
    _record$1.block_page_size,
    _record$1.collaborators_opened,
    _record$1.change_owner_popup_opened,
    _record$1.change_status_popup_opened,
    _record$1.comment_displayed_opened,
    _record$1.emoji_comment_picker_id,
    _record$1.title_opened,
    _record$1.focus_comment,
    _record$1.popup_more_comment_id,
    elements$1,
    _record$1.improvements_conversations,
    _record$1.conversations_input,
  );
}

export function upsert_element(proposals, user_id, element) {
  let id = $proposal_element.id(element);
  let proposal_id = $proposal_element.proposal_id(element);
  let _pipe = get_elements(proposals, proposal_id);
  let _pipe$1 = $list.key_set(_pipe, id, element);
  let _pipe$2 = ((_capture) => {
    return set_elements(proposals, proposal_id, _capture);
  })(_pipe$1);
  let _block;
  let $ = $proposal_element.owner(element);
  if ($ instanceof Some) {
    let uid = $[0];
    if (isEqual(new Some(uid), user_id)) {
      _block = (_capture) => { return deselect_question(_capture, id); };
    } else {
      _block = $function.identity;
    }
  } else {
    _block = (_capture) => { return deselect_question(_capture, id); };
  }
  return _block(_pipe$2);
}

export function delete_element(proposals, proposal_id, element_id) {
  let _pipe = get_elements(proposals, proposal_id);
  let _pipe$1 = $list.filter(
    _pipe,
    (element) => { return element[0] !== element_id; },
  );
  return ((_capture) => {
    return set_elements(proposals, proposal_id, _capture);
  })(_pipe$1);
}

export function remove_question(proposals, proposal_id, question_id) {
  let elements = filter_question(proposals, proposal_id, question_id);
  let _block;
  let _pipe = elements.by_proposal;
  let _pipe$1 = $dict.get(_pipe, proposal_id);
  let _pipe$2 = $result.unwrap(_pipe$1, toList([]));
  _block = compute_progress(_pipe$2);
  let progress = _block;
  let _record = proposals;
  return new Proposals(
    (() => {
      let _pipe$3 = proposals.all;
      let _pipe$4 = $list.key_find(_pipe$3, proposal_id);
      let _pipe$5 = $result.map(
        _pipe$4,
        (p) => {
          let _record$1 = p;
          return new $proposal.Proposal(
            _record$1.id,
            _record$1.project_id,
            _record$1.org_id,
            _record$1.name,
            _record$1.status,
            _record$1.display,
            _record$1.google_sheet_id,
            _record$1.kind,
            _record$1.link_id,
            _record$1.metadata,
            progress,
            _record$1.created_at,
          );
        },
      );
      let _pipe$6 = $result.map(
        _pipe$5,
        (_capture) => {
          return $list.key_set(proposals.all, proposal_id, _capture);
        },
      );
      return $result.unwrap(_pipe$6, proposals.all);
    })(),
    _record.filters,
    _record.filters_opened,
    _record.selected_questions,
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}

export function sort_elements_by_doc_id(proposals, proposal_id) {
  let _pipe = get_elements(proposals, proposal_id);
  let _pipe$1 = $list.sort(
    _pipe,
    (e1, e2) => {
      let e1$1 = $proposal_element.doc_id_order(e1[1]);
      let e2$1 = $proposal_element.doc_id_order(e2[1]);
      return $int.compare(e1$1, e2$1);
    },
  );
  return ((_capture) => {
    return set_elements(proposals, proposal_id, _capture);
  })(_pipe$1);
}

export function get_sheet_from_question_id(questions, question_id) {
  let _pipe = questions;
  let _pipe$1 = $dict.from_list(_pipe);
  let _pipe$2 = $dict.get(_pipe$1, question_id);
  let _pipe$3 = $result.map(_pipe$2, (question) => { return question.sheet; });
  return $result.unwrap(_pipe$3, new None());
}

export function deselect_all_questions(proposals) {
  let _record = proposals;
  return new Proposals(
    _record.all,
    _record.filters,
    _record.filters_opened,
    $dict.new$(),
    _record.add_opened,
    _record.more_question_opened,
    _record.more_proposal_opened,
    _record.more_unsubscriber,
    _record.block_page_size,
    _record.collaborators_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.comment_displayed_opened,
    _record.emoji_comment_picker_id,
    _record.title_opened,
    _record.focus_comment,
    _record.popup_more_comment_id,
    _record.elements,
    _record.improvements_conversations,
    _record.conversations_input,
  );
}
